module.exports = __webpack_public_path__ + "static/arnold-schwarzenegger-9d9b362b7b689768e1c1a2031a1e7281.jpg";